/**
 * @file MediaTile.tsx
 * @description Плитка картинки в «Выбрать из медиатеки» (phase19.16 Р1):
 * квадратная миниатюра, имя файла и размер; неподходящий формат — плитка
 * неактивна с подписью «не подходит по формату».
 */

import type { ContentMediaAsset } from "../../../lib/api-content-media";
import { cn } from "@/lib/utils";

interface Props {
  asset: ContentMediaAsset;
  disabled: boolean;
  onPick: () => void;
}

export function MediaTile({ asset, disabled, onPick }: Props) {
  const size = asset.width && asset.height ? `${asset.width}×${asset.height}` : null;
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onPick}
      title={asset.fileName}
      className={cn(
        "flex min-w-0 flex-col gap-1 rounded-lg p-1 text-left outline-none focus-visible:ring-2 focus-visible:ring-ring",
        disabled ? "cursor-not-allowed opacity-50" : "hover:bg-surface-low",
      )}
    >
      <span className="block aspect-square w-full overflow-hidden rounded-md bg-[repeating-conic-gradient(var(--surface-low)_0_25%,transparent_0_50%)] bg-[length:16px_16px]">
        {asset.mimeType.startsWith("image/") ? (
          <img src={asset.url} alt={asset.altText ?? ""} loading="lazy" className="size-full object-contain" />
        ) : (
          <span className="type-caption flex size-full items-center justify-center text-on-surface-variant">{asset.mimeType.startsWith("video/") ? "видео" : "звук"}</span>
        )}
      </span>
      <span className="type-caption truncate text-on-surface">{asset.fileName}</span>
      <span className="type-caption truncate text-on-surface-variant">{disabled ? "не подходит по формату" : size}</span>
    </button>
  );
}
